export default __webpack_public_path__ + "static/12-ccceb210230648943977e21f97e94d7f.png";